import type { Locale } from "@mw/shared/i18n";

export const LOCALIZED_LABELS: Record<Locale, string> = {
  sv: "Svenska",
  de: "Deutsch",
  hi: "हिन्दी",
  it: "Italiano",
  pl: "Polski",
  fr: "Français",
  ja: "日本語",
  ko: "한국어",
  es: "Español",
  en: "English",
  pt: "Português",
  zh: "简体中文",
};

/**
 * Sublabel override for locales whose plain language name is ambiguous across
 * regions. Other rows show the English language name (Swedish, Polish, …); the
 * site's `pt` locale is Brazilian Portuguese, so surface "Brazilian" to match.
 */
export const LOCALE_REGION_SUBLABELS: Partial<Record<Locale, string>> = {
  pt: "Brazilian",
};
